import { render, staticRenderFns } from "./homeLiucheng.vue?vue&type=template&id=37f0b181&"
import script from "./homeLiucheng.vue?vue&type=script&lang=js&"
export * from "./homeLiucheng.vue?vue&type=script&lang=js&"
import style0 from "./homeLiucheng.vue?vue&type=style&index=0&id=37f0b181&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports